import type { GtmInjected } from '@white-label-types/nuxtjs-gtm';

export function trackCheckoutStep(gtm: GtmInjected, step: number, option: string) {
  gtm.push({
    'event': 'checkout',
    'ecommerce': {
      'checkout': {
        'actionField': { 'step': step, 'option': option },
      },
    },
  });
}
